// extracted by mini-css-extract-plugin
module.exports = {"markerPin":"MarkerIconV3_markerPin__16o13","icon":"MarkerIconV3_icon__2mgjJ","text":"MarkerIconV3_text__1HX_R"};